/* eslint-disable */
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {OrderResponseType} from "app/features/Confirmation/types/FinalResponseType";

const initialState: ConfirmState = {
    confirmData: {} as OrderResponseType,
};

interface ConfirmState {
    confirmData: OrderResponseType
}

export const confirmSlice = createSlice({
    name: 'confirmItems',
    initialState,
    reducers: {
        confirmFinalOrder: (state, action:PayloadAction<OrderResponseType>) =>{
            state.confirmData = action.payload;
        },
    },
});

export default confirmSlice.reducer;

// export methods
export const {
    confirmFinalOrder
} = confirmSlice.actions;
